module.exports = __webpack_public_path__ + "img/horizontal_7_6_3.8d663ace.png";